import { Command } from '@/app/common/base/command'
import { InventoryFormRequirement } from '@/app/inventory-form/entities/inventory-form-requirement.entity'

export class GetInventoryFormRequirementsCommand extends Command {
    public async run(productActionId: string): Promise<InventoryFormRequirement> {
        const response = await this.client.get(`/api/inventory-form/requirements/${productActionId}`)
        return response.asEntity(InventoryFormRequirement)
    }
}
